import React from 'react'
import { Link } from 'gatsby'

import Layout from '../../components/layout'
import Image from '../images/joette-borzik.jpg'
import SEO from '../../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Joette Borzik" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Joette Borzik</h1>
        <div>
          <img
            src={Image}
            title="joette-borzik"
            width={200}
            height={291}
            className="alignleft size-full wp-image-351"
            style={{ float: 'left' }}
          />
          <p />
          <p>
            Joette, known for her high energy, enthusiasm, positive outlook on
            life and passion for learning, provides organizations and teams with
            engaging and interactive training and leadership development
            experiences. Joette specializes in leadership and employee
            development training, and has held positions such as Chief of
            Leadership and Employee Development for the U.S. Fish and Wildlife
            Service at the National Conservation Training Center in
            Shepherdstown, WV, and Program Director for the Eastern Management
            Development Center, an Office of Personnel Management national
            leadership training center.
          </p>
          <p>
            Joette loves working with high potentials and professionals seeking
            to expand their leadership and mentoring skills, those seeking more
            self- discovery and those who want their work and life to be more
            fun and meaningful. Through coaching, Joette partners with you to
            explore options and strategies so you can achieve your maximum
            potential. Joette is a Coach University graduate and completed 300
            hours of life and business coach training.
          </p>
          <p>
            Joette began her career working in natural resource management with
            the U.S. Forest Service. She has an adventurous streak and worked as
            a wildland firefighter, and later a Wildland Fire Chief, for two
            federal government agencies. Her work as a trainer began in wildland
            fire management, which led to the creation of a mentoring program
            for future fire managers. She also helped other federal agencies
            develop their own mentoring programs. Joette has a BS degree in
            Forest Science with a minor in wildlife management from the
            Pennsylvania State University. She also has a MS degree in Strategic
            Leadership from Mountain State University, plus holds numerous
            certifications and qualifications.
          </p>
          <p>
            She brings 30 years of diverse experience and perspective from work
            with the federal government, non-profits and retail. Joette is
            certified in a wide array of 360° assessment tools including the{' '}
            <em>Leadership Practices Inventory</em>®, OPM Leadership 360, and
            the <em>Benchmarks</em> 360°. She is also certified in the Strength
            Deployment Inventory®, Myers-Briggs Type Indicator® (MBTI), Extended
            DISC®, <em>The Leadership Challenge</em>® workshop, Bar-On EQ-i ®
            (emotional intelligence), numerous Coach U assessments including
            Clean Sweep® and more.
          </p>
          <p>
            Phone: | 240.440.4221 | Email:{' '}
            <a href="mailto:joette@growthjourney.com" alt="Email Joette Borzak">
              joette@growthjourney.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
